import React, { useLayoutEffect } from 'react';

const ProductElement = (props) => {
	if (!props.element) {
		return <></>;
	}

	const element = props.element;
	const imgId = `main-elem-${props.image ? 'image-' : ''}${props.index}`;

	const onMouseOver = () => {
		const hoverUrl = element.hoverUrl?.value || element.imageUrl?.value;
		document.getElementById(imgId).setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', hoverUrl);
	};

	const onMouseOut = () => {
		const imageUrl = element.imageUrl?.value;
		document.getElementById(imgId).setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageUrl);
	};

	const handleOnKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			props.onClick?.(event);
		}
	}

	useLayoutEffect(() => {
		props.onEnter?.();
	}, []);

	return (
		<g
			className="InteractLayer fadein-0s show"
			id={`elem-wrapper-image-${props.index}`}
			onKeyDown={handleOnKeyDown}
			role='button'
			aria-label={element?.name}
			tabIndex={0}
		>
			<g>
				<image
					id={imgId}
					defaulturl={element.imageUrl?.value}
					xlinkHref={element.imageUrl?.value}
					x={element?.x?.value}
					y={element?.y?.value}
					width={props.element?.width?.value}
					height={props.element?.height?.value}
					rx={props.element?.radius?.value}
				/>
			</g>
			<g>
				<rect
					id={`interactClickableArea-${props.image ? 'image-' : ''}${props.index}`}
					gid={element?.grid?.value || 'button'}
					x={element?.x?.value}
					y={element?.y?.value}
					width={props.element?.width?.value}
					height={props.element?.height?.value}
					rx={props.element?.radius?.value}
					onClick={props.onClick}
					onTouchStart={props.onClick}
					onMouseOver={props.isMobile ? undefined : onMouseOver}
					onMouseOut={props.isMobile ? undefined : onMouseOut}
					fill={'transparent'}
				/>
			</g>
		</g>
	);
};

export default ProductElement;
